import React, { useState, useRef, useEffect } from 'react';
import { Form, Button, Card, Spinner } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import Swal from 'sweetalert2'

const Register = () => {
    const userRef = useRef();
    const [name, setUsername] = useState('');
    const [lastname, setLastname] = useState('');
    const [service_id, setService] = useState('');
    const [email, setEmail] = useState('');
    const [sessionsWeek, setSessions] = useState('');
    const [urlRoutine, setRutine] = useState('');
    const [documentNumber, setDocumentNumber] = useState('');
    const [phone, setPhone] = useState('');
    const [birthDate, setBirthdate] = useState('');
    const [firstPayment, setFirstPayment] = useState('');
    const [error, setError] = useState(null);
    const [successMessage, setSuccessMessage] = useState('');
    const [loading, setLoading] = useState(false);
    const [documentStatus, setDocumentStatus] = useState(null);
    const [tyc, setTyc] = useState(false);

    const navigate = useNavigate();

    useEffect(() => {
        userRef.current.focus();
    }, []);

    const getServiceName = (id) => {
        if (id === 1) return "Sala libre";
        if (id === 2) return "Sala HIFT";
        if (id === 3) return "Personalizado";
        if (id === 4) return "Mixto";
        return "Desconocido";
    };

    const formData = {
        id: 0,
        name,
        lastname,
        email,
        urlRoutine,
        documentNumber,
        phone,
        birthDate,
        firstPayment,
        usertype: 3,
        service_id,
        sessionsWeek,
        tyc: 1
    };

    const sanitizedData = Object.fromEntries(
        Object.entries(formData).map(([key, value]) => [key, value === '' ? null : value])
    );

    const handleSessionsChange = (e) => {
        const value = e.target.value;
        // Solo permite números del 1 al 7
        if (value === '' || (/^\d+$/.test(value) && parseInt(value) >= 1 && parseInt(value) <= 7)) {
            setSessions(value);
        }
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        setError(null);
        setLoading(true);
        setSuccessMessage('');

        if (!name || !lastname || !documentNumber || !firstPayment) {
            setError('Por favor, completa todos los campos obligatorios.');
            setLoading(false);
            return;
        }

        const confirmMessage = `
            <p><strong>Nombre:</strong> ${name}</p>
            <p><strong>Apellido:</strong> ${lastname}</p>
            <p><strong>Servicio:</strong> ${getServiceName(service_id)}</p>
            <p><strong>Sesiones por semana:</strong> ${sessionsWeek}</p>
            <p><strong>Email:</strong> ${email}</p>
            <p><strong>Documento:</strong> ${documentNumber}</p>
            <p><strong>Teléfono:</strong> ${phone}</p>
            <p><strong>Fecha de Nacimiento:</strong> ${birthDate}</p>
            <p><strong>Fecha de primera cuota:</strong> ${firstPayment}</p>
        `;

        // Mostrar el diálogo de confirmación
        const result = await Swal.fire({
            title: '¿Confirmar registro?',
            html: confirmMessage,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sí, confirmar',
            cancelButtonText: 'Cancelar'
        });

        if (result.isConfirmed) {
            try {
                const response = await axios.post('https://wellness.nextriking.com/api/users/add', sanitizedData);

                if (response.status === 200) {
                    setSuccessMessage("Usuario agregado!");
                    // navigate('/dashboard'); // Descomenta esta línea si quieres redirigir al usuario después del registro
                }
            } catch (error) {
                if (error.response && error.response.status === 400) {
                    setError('Usuario o contraseña incorrectos. Verifica tus credenciales e intenta de nuevo.');
                } else {
                    setError('Error al registrar. Inténtalo de nuevo más tarde.');
                }
                console.error('Error al registrar usuario:', error);
            }
        }
        setLoading(false);
    };

    const handleDocumentChange = async (e) => {
        const value = e.target.value;
        if (/^\d*$/.test(value) && value.length <= 8) {
            setDocumentNumber(value);

            if (value.length === 8) {
                try {
                    const response = await axios.post(
                        "https://wellness.nextriking.com/api/users/dni",
                        { documentNumber: value },
                        { headers: { "Content-Type": "application/json" } }
                    );
                    console.log("response:", response);
                    const exists = response.data.body.exists;
                    setDocumentStatus(exists);
                } catch (error) {
                    console.error("Error al verificar el DNI:", error);
                    setDocumentStatus(null);
                }
            } else {
                setDocumentStatus(null);
            }
        }
    };

    const handleServiceChange = (e) => {
        const selectedServiceId = Number(e.target.value);
        setService(selectedServiceId);

        if (selectedServiceId === 2) {
            setRutine('https://docs.google.com/spreadsheets/d/1cXFc8fMhAkg5goBpBKiO8BZ8G97x5EIN/edit?rtpof=true&sd=true&gid=1926737728#gid=1926737728');
        }
    };

    return (
        <div className="d-flex justify-content-center" style={{ minHeight: '100vh', backgroundColor: '#f8f9fa', padding: '24px 16px' }}>
            <Card className="shadow-lg" style={{ width: '100%', maxWidth: '560px', padding: '20px', alignSelf: 'flex-start' }}>
                <Card.Body>
                    <div style={{ display: 'flex', justifyContent: 'flex-start' }}>
                        <button type="button" className="btn btn-secondary" onClick={() => navigate("/dashboard")}>
                            Volver atrás
                        </button>
                    </div>
                    <Card.Title className="text-center">Dar de alta usuario</Card.Title>
                    {error && <p className="text-danger">{error}</p>}
                    {successMessage && <p className="text-success">{successMessage}</p>}
                    <Form onSubmit={handleSubmit}>
                        <Form.Group controlId="formBasicUsername">
                            <Form.Label>Nombre</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="Nombre"
                                value={name}
                                ref={userRef}
                                onChange={(e) => setUsername(e.target.value)}
                            />
                        </Form.Group>
                        <Form.Group controlId="formBasicLastname">
                            <Form.Label>Apellido</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="Apellido"
                                value={lastname}
                                onChange={(e) => setLastname(e.target.value)}
                            />
                        </Form.Group>

                        <Form.Group controlId="formBasicService">
                            <Form.Label>Servicio</Form.Label>
                            <Form.Select
                                value={service_id}
                                onChange={(e) => handleServiceChange(e)}
                            >
                                <option value="">Selecciona una opción</option>
                                <option value="1">Sala libre</option>
                                <option value="2">Sala HIFT</option>
                                <option value="3">Personalizado</option>
                                <option value="4">Mixto</option>
                            </Form.Select>
                        </Form.Group>
                        <Form.Group controlId="formBasicDoc">
                            <Form.Label>Sesiones por semana</Form.Label>
                            <Form.Control
                                type="tel"
                                inputMode="numeric"
                                placeholder="Sesiones semanales"
                                value={sessionsWeek}
                                onChange={handleSessionsChange}
                            />
                            <Form.Text className="text-muted">
                                Entre 1 y 7 sesiones permitidas.
                            </Form.Text>
                        </Form.Group>
                        <Form.Group controlId="formBasicEmail">
                            <Form.Label>Email</Form.Label>
                            <Form.Control
                                type="email"
                                placeholder="Email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                            />
                        </Form.Group>

                        {/* <Form.Group controlId="formBasicFirstPayment">
                            <Form.Label>Rutina</Form.Label>
                            <Form.Control
                                type="text"
                                value={urlRoutine}
                                onChange={(e) => setRutine(e.target.value)}
                            />
                        </Form.Group> */}

                        <Form.Group controlId="formBasicDoc">
                            <Form.Label>Nro Documento</Form.Label>
                            <Form.Control
                                type="tel"
                                inputMode="numeric"
                                placeholder="Document"
                                value={documentNumber}
                                onChange={handleDocumentChange}
                            />
                            {documentStatus !== null && (
                                <p style={{
                                    color: documentStatus ? "red" : "green",
                                    fontWeight: "bold",
                                    marginTop: "5px"
                                }}>
                                    {documentStatus ? "❌ Este documento ya está registrado." : "✅ El documento es nuevo."}
                                </p>
                            )}
                        </Form.Group>
                        <Form.Text className="text-muted">
                            Máximo 8 números permitidos.
                        </Form.Text>

                        <Form.Group controlId="formBasicPhone">
                            <Form.Label>Teléfono</Form.Label>
                            <Form.Control
                                type="tel"
                                placeholder="Teléfono de contacto y WhatsApp"
                                value={phone}
                                onChange={(e) => setPhone(e.target.value)}
                            />
                        </Form.Group>

                        <Form.Group controlId="formBasicBirthdate">
                            <Form.Label>Fecha de Nacimiento</Form.Label>
                            <Form.Control
                                type="date"
                                value={birthDate}
                                onChange={(e) => setBirthdate(e.target.value)}
                            />
                        </Form.Group>

                        <Form.Group controlId="formBasicFirstPayment">
                            <Form.Label>Fecha de primera cuota</Form.Label>
                            <Form.Control
                                type="date"
                                value={firstPayment}
                                onChange={(e) => setFirstPayment(e.target.value)}
                            />
                        </Form.Group>

                        <Form.Group controlId="formBasicTyc" className="mt-3">
                            <Form.Check
                                type="checkbox"
                                label={
                                    <span>
                                        Acepta los Terminos y condiciones
                                    </span>
                                }
                                checked={tyc}
                                onChange={(e) => setTyc(e.target.checked)}
                                required
                            />
                        </Form.Group>
                        <br />
                        <Button
                            variant="primary"
                            type="submit"
                            block
                            disabled={loading || documentStatus === true || !tyc}
                        >
                            {loading ? <Spinner animation="border" size="sm" /> : "Registrar"}
                        </Button>

                    </Form>
                </Card.Body>
            </Card>
        </div>
    );
};

export default Register;
